import { render, staticRenderFns } from "./DeliveryProofQueue.vue?vue&type=template&id=fc315568&scoped=true"
import script from "./DeliveryProofQueue.vue?vue&type=script&lang=js"
export * from "./DeliveryProofQueue.vue?vue&type=script&lang=js"
import style0 from "./DeliveryProofQueue.vue?vue&type=style&index=0&id=fc315568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc315568",
  null
  
)

export default component.exports